import React from 'react';
import { MapPin, Phone, Mail, Building2 } from 'lucide-react';
import { CONTACT_INFO, COMPANY_INFO } from '../data/mockData';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';

const Contact = () => {
  return (
    <div className="page-container">
      {/* Page Header */}
      <section className="page-header-section">
        <div className="section-container">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">
            Get in touch with our global offices for all your commodity needs
          </p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="contact-section">
        <div className="section-container">
          <div className="contact-intro">
            <h2 className="contact-intro-title">Let's Build a Partnership</h2>
            <p className="contact-intro-text">
              Whether you're looking to source premium commodities or discuss potential 
              partnerships, our team is ready to assist you. Reach out to any of our 
              global offices.
            </p>
          </div>

          {/* Email Section */}
          <div className="contact-email-section">
            <Mail className="contact-email-icon" size={32} />
            <div>
              <h3 className="contact-email-title">Email Us</h3>
              <a href={`mailto:${CONTACT_INFO.email}`} className="contact-email-link">
                {CONTACT_INFO.email}
              </a>
            </div>
          </div>

          {/* Office Locations */}
          <div className="offices-grid">
            {CONTACT_INFO.offices.map((office, index) => (
              <Card key={index} className="office-card">
                <CardHeader>
                  <div className="office-card-icon">
                    <Building2 size={32} />
                  </div>
                  <CardTitle className="office-card-title">{office.location}</CardTitle>
                </CardHeader>
                <CardContent className="office-card-content">
                  <div className="office-info-item">
                    <MapPin size={18} className="office-info-icon" />
                    <p className="office-info-text">{office.address}</p>
                  </div>
                  <div className="office-info-item">
                    <Phone size={18} className="office-info-icon" />
                    <a href={`tel:${office.phone}`} className="office-info-link">
                      {office.phone}
                    </a>
                  </div>
                </CardContent>
              </Card>
            ))}

            {/* India Office - Coming Soon */}
            <Card className="office-card office-card-coming-soon">
              <CardHeader>
                <div className="office-card-icon">
                  <Building2 size={32} />
                </div>
                <CardTitle className="office-card-title">India Office</CardTitle>
              </CardHeader>
              <CardContent className="office-card-content">
                <p className="office-coming-soon-text">Opening Soon</p>
                <p className="office-info-text">
                  Our India office will be operational shortly. For inquiries, 
                  please contact our other offices.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Business Hours / Additional Info */}
      <section className="contact-additional-section">
        <div className="section-container">
          <div className="contact-additional-card">
            <h3 className="contact-additional-title">Business Hours</h3>
            <p className="contact-additional-text">
              Our teams operate across multiple time zones to serve you better. 
              We typically respond to all inquiries within 24-48 hours.
            </p>
            <div className="contact-additional-features">
              <div className="contact-additional-feature">
                <span className="contact-additional-feature-label">Response Time:</span>
                <span className="contact-additional-feature-value">24-48 hours</span>
              </div>
              <div className="contact-additional-feature">
                <span className="contact-additional-feature-label">Support:</span>
                <span className="contact-additional-feature-value">Global Coverage</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
